import { AssetType, Brand, Environment } from './types/common'

type MapBrandToDomain = {
  [key in Environment]: {
    [key in Brand]: string
  }
}
export const MAP_BRAND_TO_DOMAIN: MapBrandToDomain = {
  [Environment.development]: {
    [Brand.all]: '', // TS needs this - we could've exluded it above in the type definition, but then would've to do the same where this const is being used - this is the compromise
    [Brand.astrowoche]: 'https://astrowoche.testing.toeknee.zone',
    [Brand.autozeitung]: 'https://autozeitung.testing.toeknee.zone',
    [Brand.bravo]: 'https://bravo.testing.toeknee.zone',
    [Brand.cosmopolitan]: 'https://cosmopolitan.testing.toeknee.zone',
    [Brand.happinez]: 'https://happinez.testing.toeknee.zone',
    [Brand.intouch]: 'https://intouch.testing.toeknee.zone',
    [Brand.lecker]: 'https://lecker.testing.toeknee.zone',
    [Brand.liebenswert]: 'https://liebenswert.testing.toeknee.zone',
    [Brand.maennersache]: 'https://maennersache.testing.toeknee.zone',
    [Brand.praxisvita]: 'https://praxisvita.testing.toeknee.zone',
    [Brand.selbst]: 'https://selbst.testing.toeknee.zone',
    [Brand.tvmovie]: 'https://tvmovie.testing.toeknee.zone',
    [Brand.whitelabel]: 'https://whitelabel.testing.toeknee.zone',
    [Brand.wunderweib]: 'https://wunderweib.testing.toeknee.zone',
    [Brand.todaysgolfer]: 'https://todaysgolfer.testing.toeknee.zone'
  },
  [Environment.testing]: {
    [Brand.all]: '', // TS needs this - we could've exluded it above in the type definition, but then would've to do the same where this const is being used - this is the compromise
    [Brand.astrowoche]: 'https://astrowoche.testing.toeknee.zone',
    [Brand.autozeitung]: 'https://autozeitung.testing.toeknee.zone',
    [Brand.bravo]: 'https://bravo.testing.toeknee.zone',
    [Brand.cosmopolitan]: 'https://cosmopolitan.testing.toeknee.zone',
    [Brand.happinez]: 'https://happinez.testing.toeknee.zone',
    [Brand.intouch]: 'https://intouch.testing.toeknee.zone',
    [Brand.lecker]: 'https://lecker.testing.toeknee.zone',
    [Brand.liebenswert]: 'https://liebenswert.testing.toeknee.zone',
    [Brand.maennersache]: 'https://maennersache.testing.toeknee.zone',
    [Brand.praxisvita]: 'https://praxisvita.testing.toeknee.zone',
    [Brand.selbst]: 'https://selbst.testing.toeknee.zone',
    [Brand.tvmovie]: 'https://tvmovie.testing.toeknee.zone',
    [Brand.whitelabel]: 'https://whitelabel.testing.toeknee.zone',
    [Brand.wunderweib]: 'https://wunderweib.testing.toeknee.zone',
    [Brand.todaysgolfer]: 'https://todaysgolfer.testing.toeknee.zone'
  },
  [Environment.staging]: {
    [Brand.all]: '', // TS needs this - we could've exluded it above in the type definition, but then would've to do the same where this const is being used - this is the compromise
    [Brand.astrowoche]: 'https://astrowoche.staging.toeknee.zone',
    [Brand.autozeitung]: 'https://autozeitung.staging.toeknee.zone',
    [Brand.bravo]: 'https://bravo.staging.toeknee.zone',
    [Brand.cosmopolitan]: 'https://cosmopolitan.staging.toeknee.zone',
    [Brand.happinez]: 'https://happinez.staging.toeknee.zone',
    [Brand.intouch]: 'https://intouch.staging.toeknee.zone',
    [Brand.lecker]: 'https://lecker.staging.toeknee.zone',
    [Brand.liebenswert]: 'https://liebenswert.staging.toeknee.zone',
    [Brand.maennersache]: 'https://maennersache.staging.toeknee.zone',
    [Brand.praxisvita]: 'https://praxisvita.staging.toeknee.zone',
    [Brand.selbst]: 'https://selbst.staging.toeknee.zone',
    [Brand.tvmovie]: 'https://tvmovie.staging.toeknee.zone',
    [Brand.whitelabel]: 'https://whitelabel.staging.toeknee.zone',
    [Brand.wunderweib]: 'https://wunderweib.staging.toeknee.zone',
    [Brand.todaysgolfer]: 'https://todaysgolfer.staging.toeknee.zone'
  },
  [Environment.production]: {
    [Brand.all]: '', // TS needs this - we could've exluded it above in the type definition, but then would've to do the same where this const is being used - this is the compromise
    [Brand.astrowoche]: 'https://astrowoche.wunderweib.de',
    [Brand.autozeitung]: 'https://www.autozeitung.de',
    [Brand.bravo]: 'https://www.bravo.de',
    [Brand.cosmopolitan]: 'https://www.cosmopolitan.de',
    [Brand.happinez]: 'https://magazin.happinez.de',
    [Brand.intouch]: 'https://intouch.wunderweib.de',
    [Brand.lecker]: 'https://www.lecker.de',
    [Brand.liebenswert]: 'https://www.liebenswert-magazin.de',
    [Brand.maennersache]: 'https://www.maennersache.de',
    [Brand.praxisvita]: 'https://praxisvita.production.toeknee.zone',
    [Brand.selbst]: 'https://www.selbst.de',
    [Brand.tvmovie]: 'https://www.tvmovie.de',
    [Brand.whitelabel]: 'https://whitelabel.production.toeknee.zone',
    [Brand.wunderweib]: 'https://www.wunderweib.de',
    [Brand.todaysgolfer]: 'https://todaysgolfer.production.toeknee.zone'
  }
}

/**
 * 'TONI {@link Brand} and 'Commerce Engine's Affiliate Publisher' may not always bethe same value
 *
 * so this allows us to map any differences between the systems
 */
export const MAP_BRAND_TO_COMMERCE_AFFILIATE_PUBLISHER: Partial<Record<Brand, string>> = {
  [Brand.todaysgolfer]: 'TodaysGolfer.de'

  /**
   * NOTE:
   *  {@link Brand}.todaysgolferuk has *not* been added yet
   * .. but when it is .. then we will most-likely map to CommerceEngine's 'TodaysGolfer'
   *  e.g. `[Brand.todaysgolferuk]: 'TodaysGolfer'`
   */
}

export const getBrandFromCommerceAffiliatePublisher = (commerceAffiliatePublisher: string): string | undefined => {
  return Object.keys(MAP_BRAND_TO_COMMERCE_AFFILIATE_PUBLISHER).find(key => MAP_BRAND_TO_COMMERCE_AFFILIATE_PUBLISHER[key as Brand] === commerceAffiliatePublisher)
}

export const TYPES_WITH_DUPLICATION = [AssetType.Article, AssetType.Recipe]
export const URL_PLACEHOLDER_NEW_NODE_ID = '{12345}'
